// CustomHeader.jsx
import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect
} from "react";

const CustomHeader = forwardRef((props, ref) => {
  const { columnSort, setSorted } = props.innerHeaderComponentParams;
  const { displayName } = props;
  const [sortDirection, setSortDirection] = useState(columnSort);

  // AG-Grid calls this when you do api.refreshHeader()
  useImperativeHandle(ref, () => ({
    refresh(params) {
      console.log("CustomHeader.refresh()", params);
      setSortDirection(params.columnSort);
      return true;  // ← tell AG-Grid “I handled it”
    }
  }), []);

  // also sync if AG-Grid tears you down & remounts with new props
  useEffect(() => {
    setSortDirection(columnSort);
  }, [columnSort]);

  const onSortChanged = () => {
    const next =
      sortDirection === "asc"  ? "desc" :
      sortDirection === "desc" ? null   :
                                 "asc";
    setSortDirection(next);
    setSorted(next);
  };

  return (
    <div
      className="d-flex align-items-center gap-2 cursor-pointer"
      onClick={onSortChanged}
    >
      <span>{displayName}</span>
      {sortDirection === "asc"  && <i className="bi bi-arrow-up"></i>}
      {sortDirection === "desc" && <i className="bi bi-arrow-down"></i>}
    </div>
  );
});

export default CustomHeader;
